
import React from 'react';

const FAQ = () => {
  const faqItems = [
    {
      question: "Quels types de métaux rachetez-vous ?",
      answer: "Nous rachetons tous types de métaux : ferraille, cuivre, aluminium, inox, plomb, zinc, laiton, et batteries. Nos experts identifient et évaluent précisément chaque type de métal."
    },
    {
      question: "Comment sont fixés vos prix d'achat ?",
      answer: "Nos prix suivent les cours internationaux des métaux, actualisés quotidiennement. Nous garantissons des prix transparents et compétitifs basés sur la qualité et le type de métal."
    },
    {
      question: "Proposez-vous un service de collecte ?",
      answer: "Oui, nous proposons un service de collecte sur site pour les gros volumes. Notre équipe intervient rapidement avec les équipements adaptés dans toute notre zone de couverture."
    },
    {
      question: "Faut-il trier les métaux avant de les apporter ?",
      answer: "Le tri préalable optimise le prix de rachat, mais n'est pas obligatoire. Nos experts peuvent effectuer le tri sur place et vous conseiller pour maximiser la valeur de vos métaux."
    },
    {
      question: "Quelles sont vos zones d'intervention ?",
      answer: "Nous intervenons dans toute l'Occitanie et en Île-de-France : Aveyron, Haute-Garonne, Tarn, Lot, Cantal, Lozère, Hérault, Tarn-et-Garonne, et Val-d'Oise."
    },
    {
      question: "Délivrez-vous des certificats de destruction ?",
      answer: "Oui, nous fournissons tous les certificats de destruction et documents de traçabilité nécessaires, notamment pour les entreprises soumises à des obligations réglementaires."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-fabre-gray mb-4">
            Questions fréquentes sur l'achat de métaux
          </h2>
          <p className="text-gray-600">
            Tout ce que vous devez savoir sur nos services d'achat de métaux
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {faqItems.map((item, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm">
                <h3 className="font-bold text-gray-800 mb-3">
                  {item.question}
                </h3>
                <p className="text-gray-600 text-sm">
                  {item.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
